import React from "react";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { selectAllFormSettings } from "../../../../../redux/slices/formSettingsSlice";
import {
    selectHistoricalTotalCount,
    selectHistoricalTotalImpact,
    selectRecurringTransactionHistory,
} from "../../../../../redux/slices/recurringSummaryHistorySlice";
import RecurringSummaryHistoryDetails from "./RecurringSummaryHistoryDetails";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryHistoryDetails = ({ control }) => {
    const { currency } = useSelector(selectAllFormSettings);
    const { options = {} } = control;
    const {
        historyLabel = "History",
        transactionIdLabel = "Transaction %TransactionID%",
        statusLabel = "Status",
        dateLabel = "Date",
        totalImpactLabel = "Your Total Impact",
    } = options;

    const transactionHistory = useSelector(selectRecurringTransactionHistory);
    const historicalTotalCount = useSelector(selectHistoricalTotalCount);
    const historicalTotalImpact = useSelector(selectHistoricalTotalImpact);

    const numberOfItems = transactionHistory?.length;
    const formattedHistoricalTotalCount = `${historicalTotalCount} ${
        historicalTotalCount > 1 ? "Donations" : "Donation"
    }`;
    const totalDollarValueOfImpact = currencyString(
        historicalTotalImpact,
        currency,
    );

    const recurringSummaryHistoryProps = {
        currency,
        dateLabel,
        formattedHistoricalTotalCount,
        historicalTotalImpact,
        historyLabel,
        numberOfItems,
        statusLabel,
        totalDollarValueOfImpact,
        totalImpactLabel,
        transactionHistory,
        transactionIdLabel,
    };

    return <RecurringSummaryHistoryDetails {...recurringSummaryHistoryProps} />;
};

export default ConnectedRecurringSummaryHistoryDetails;
